import React from 'react';

export default class CheckboxInput extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
    };
  }

  handleChange = (e) => {
    this.props.onChange(this.props.objectKey, !this.props.object);
  }

  componentWillReceiveProps = (props) => {
  }

  render = () => {
    return (
      <input 
        type="checkbox"
        className="edit-checkbox"
        onChange={this.handleChange}
        checked={this.props.object || false}
        value={this.props.object ? "on" : "off"}
        disabled={this.props.disabled}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/input/CheckboxInput.js